import type { TIrrigationZoneEmitter, TPoint } from 'stores/fieldAssetStore/helperTypes'

export const getIrrigationZoneEmitterExternalVendorNames = ({
  irrigationZoneEmitter,
  points,
}: {
  irrigationZoneEmitter: Pick<TIrrigationZoneEmitter, 'externalVendorNames' | 'irrigationZoneEmitterId'>
  points: Pick<TPoint, 'externalVendorNames' | 'irrigationEmitterZoneIds'>[]
}) => [
  ...new Set([
    ...(irrigationZoneEmitter.externalVendorNames ?? []),
    ...points
      .filter((point) =>
        point.irrigationEmitterZoneIds?.includes(irrigationZoneEmitter.irrigationZoneEmitterId),
      )
      .flatMap((point) => point.externalVendorNames ?? []),
  ]),
]
